<template>
  <div>
    <div v-for="(decisionDataDateRange, index) of Object.keys(model.$getData())" :key="index" class="mt-5">
      <h2>{{ dictionary[decisionDataDateRange].name }}</h2>

      <decision-ranges
        :model="model[decisionDataDateRange]"
        :types="dictionary[decisionDataDateRange].types"
        :with-amount="false"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { PublicSettings } from '@/enums/publicSettings.enum';

import DecisionRanges from './DecisionRanges';

export default {
  components: { DecisionRanges },
  props: {
    model: { type: Object, fieldRequired: true }
  },
  computed: mapState({
    dictionary: state =>
      JSON.parse(state.setting.settings[PublicSettings.DECISION_DATA_DATES_DICTIONARY]?.value || '{}')
  })
};
</script>
